import styled from 'styled-components'

import { backgroundTypes, cssTypes, displayTypes, textTypes } from '../types'
import { background, css, display, text } from '../util'

/**
 * @namespace Label
 * @desc Primitive styled-component 💅
 * @return {Function} React component
 */
const Label = styled.label`
  ${background};
  ${css};
  ${display};
  ${text};
`

/**
 * @name defaultProps
 * @memberof Label
 * @desc Primitive's default properties
 */
Label.defaultProps = {
  fontSize: 'baseFontSize',
}

/**
 * @name propTypes
 * @memberof Label
 * @desc Primitive's prop type definitions
 */
Label.propTypes = {
  ...backgroundTypes,
  ...cssTypes,
  ...displayTypes,
  ...textTypes,
}

/** @component */
export default Label
